import { render, staticRenderFns } from "./PersonalIdExampleConfirm.vue?vue&type=template&id=25a3ffc2&scoped=true&"
import script from "./PersonalIdExampleConfirm.vue?vue&type=script&lang=ts&"
export * from "./PersonalIdExampleConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalIdExampleConfirm.vue?vue&type=style&index=0&id=25a3ffc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3ffc2",
  null
  
)

export default component.exports